import { render, staticRenderFns } from "./PortfolioDynamics.vue?vue&type=template&id=64715a9c&"
import script from "./PortfolioDynamics.vue?vue&type=script&lang=js&"
export * from "./PortfolioDynamics.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDynamics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports